import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type WizardStepStatus = 'done' | 'active' | 'upcoming';

export interface WizardStepItem {
  label: string;
  icon: 'business' | 'directors' | 'bank' | 'documents';
}

@Component({
  selector: 'app-wizard-stepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './wizard-stepper.component.html',
  styleUrl: './wizard-stepper.component.scss',
})
export class WizardStepperComponent {
  @Input({ required: true }) steps: WizardStepItem[] = [];
  @Input() activeIndex = 0;

  getStatus(index: number): WizardStepStatus {
    if (index < this.activeIndex) return 'done';
    if (index === this.activeIndex) return 'active';
    return 'upcoming';
  }
}

